import { csvField } from '@/features/monopoly/winnersCsv';
import type { MorrisonsPayload } from './report';
import { stickersTotal, weekStickers } from './derive';

export { downloadCsv } from '@/features/monopoly/winnersCsv';

/*
 * The weekly summary as a CSV, built in the browser from the payload — the
 * dashboard's table with a row per week, plus the campaign total. Comma
 * separated with a UTF-8 BOM for a UK Excel; raw numbers (no thousands
 * separator) so the sheet can add them up; empty for a figure not measured.
 * Fields go through the shared formula-injection guard.
 */
export function weeklySummaryCsv(data: MorrisonsPayload): string {
  const header = [
    'Week',
    'Start',
    'End',
    'Status',
    'Visitors',
    'Opt-ins',
    'Active users',
    'Stickers scanned',
    'Flowpacks granted',
    'Flowpacks opened',
    'Lottery tickets',
    'Game plays',
    'Referrals',
    'Shares',
  ];
  const status = { done: 'Done', live: 'In progress', planned: 'Planned' } as const;
  const rows = data.weeks.map((w) => [
    w.week,
    w.start,
    w.end,
    status[w.status],
    w.visitors,
    w.optIns,
    w.activeUsers,
    weekStickers(w),
    w.flowpacksGranted,
    w.flowpacksOpened,
    w.lotteryTickets,
    w.gamePlays,
    w.referrals,
    w.shares,
  ]);
  const t = data.totals;
  rows.push([
    'Total',
    data.campaign.start,
    data.campaign.end,
    '',
    t.uniqueVisitors,
    t.optIns,
    t.activeUsers,
    stickersTotal(t) ?? t.newCards,
    Object.values(t.flowpacksGranted).reduce((a, b) => a + b, 0),
    t.flowpacksOpened,
    t.prizes.lottery,
    t.gamePlays,
    t.referral.redeemed,
    t.shares,
  ]);
  const line = (cells: Array<string | number | null>) => cells.map((c) => csvField(c == null ? '' : String(c))).join(',');
  return '\uFEFF' + [line(header), ...rows.map(line)].join('\r\n') + '\r\n';
}
